
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91typeId_93B2qyzB9hvWOnRAXt7_75gmBL0QpcfQn9EAet8xfmLMUMeta } from "/opt/buildhome/repo/web/pages/tools/items/[typeId].vue?macro=true";
import { default as _91typeId_93JcplNpvF4ldkfox5ZZ_jooTBol96HSagYTKI15_13a4Meta } from "/opt/buildhome/repo/web/pages/tools/ships/[typeId].vue?macro=true";
import { default as fit_45diffkSgWQshBM2uu6VS0XVCxjZr9wDCiJrVKUCGl_DToklAMeta } from "/opt/buildhome/repo/web/pages/tools/fit-diff.vue?macro=true";
import { default as indexTKv4W7lGYKF8_xCsob66NuamJDXRdw7brbiQpS66hIcMeta } from "/opt/buildhome/repo/web/pages/tools/items/index.vue?macro=true";
import { default as indexH_0mUhJjdhNbkvIL9SCui_JZfoNwXClIL404F5UdSIcMeta } from "/opt/buildhome/repo/web/pages/tools/ships/index.vue?macro=true";
import { default as _91id_93l334Wnz57AO8oWUDJlTVdLZkn2esbxHKAMlnV52zq8EMeta } from "/opt/buildhome/repo/web/pages/intel/[type]/[id].vue?macro=true";
import { default as scoutVUncqSMdjDgzaSbsJDSwY3_5INusQCkbvZPop6ZkmSMMeta } from "/opt/buildhome/repo/web/pages/scout.vue?macro=true";
import { default as indexwPthUYNyCtguBES27skWwYE9TwFw44e4r1Wnq3OOgZkMeta } from "/opt/buildhome/repo/web/pages/tools/index.vue?macro=true";
import { default as indexH81T37Qawm_OWckTfq1xujHhJej6sqf5OkyhUFhRK_sMeta } from "/opt/buildhome/repo/web/pages/index.vue?macro=true";
export default [
  {
    name: "tools-items-typeId",
    path: "/tools/items/:typeId()",
    component: () => import("/opt/buildhome/repo/web/pages/tools/items/[typeId].vue")
  },
  {
    name: "tools-ships-typeId",
    path: "/tools/ships/:typeId()",
    component: () => import("/opt/buildhome/repo/web/pages/tools/ships/[typeId].vue")
  },
  {
    name: "tools-fit-diff",
    path: "/tools/fit-diff",
    component: () => import("/opt/buildhome/repo/web/pages/tools/fit-diff.vue")
  },
  {
    name: "tools-items",
    path: "/tools/items",
    component: () => import("/opt/buildhome/repo/web/pages/tools/items/index.vue")
  },
  {
    name: "tools-ships",
    path: "/tools/ships",
    component: () => import("/opt/buildhome/repo/web/pages/tools/ships/index.vue")
  },
  {
    name: "intel-type-id",
    path: "/intel/:type()/:id()",
    component: () => import("/opt/buildhome/repo/web/pages/intel/[type]/[id].vue")
  },
  {
    name: "scout",
    path: "/scout",
    component: () => import("/opt/buildhome/repo/web/pages/scout.vue")
  },
  {
    name: "tools",
    path: "/tools",
    component: () => import("/opt/buildhome/repo/web/pages/tools/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/web/pages/index.vue")
  }
]